<template>
    <div class="body d-flex py-lg-3 py-md-2 mb-5">
        <div class="container-xxl">
            <h1 class="fw-bold page-title d-none">
                Προωθητικό υλικό
            </h1>

            <div v-if="currentBranch" class="row clearfix">
                <!-- B2C / B2B promotional images -->
                <section v-for="section in currentBranch.sections" :key="section.title"
                    class="shadow py-4 my-3 px-3 rounded">
                    <h2 class="text-primary fw-bold">
                        {{ section.title }}
                    </h2>

                    <hr>


                    <div class="row text-center flex-column-mobile">
                        <div v-for="(image, index) in section.images" :key="image" class="col mb-4">
                            <div class="promo-image-container">
                                <img :src="image" :alt="`${section.title} - ${currentBranch.name} - ${index + 1}`"
                                    class="promo-image" loading="lazy">

                                <div class="promo-image-actions">
                                    <a :href="image" :download="`${branch}-${section.title}-${index + 1}.jpg`"
                                        class="btn btn-primary">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20"
                                            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                            stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                                            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                                            <path d="m7 10 5 5 5-5" />
                                            <path d="M12 15V3" />
                                        </svg>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>

                </section>

                <!-- Branch video -->
                <section v-if="currentBranch.video" class="shadow py-4 my-3 px-3 rounded">
                    <h2 class="text-primary fw-bold">Video</h2>

                    <hr>

                    <div class="promo-video">
                        <iframe :src="currentBranch.video" :title="`Προωθητικό βίντεο - ${currentBranch.name}`"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                    </div>
                </section>
            </div>

            <div v-else class="py-4">
                <p>Δεν υπάρχει διαθέσιμο προωθητικό υλικό.</p>
            </div>
        </div>
    </div>
</template>

<script setup>
import { computed, ref, onMounted, onUnmounted } from 'vue';

const hostname = ref('');

const branches = {
    'papagou-cholargou': {
        name: 'Παπάγου - Χολαργός',

        sections: [
            {
                title: 'B2C',
                images: [
                    new URL(
                        '../assets/images/promo/papagou-xolargou/B2C-2.jpg',
                        import.meta.url
                    ).href,
                    new URL(
                        '../assets/images/promo/papagou-xolargou/B2C-1.jpg',
                        import.meta.url
                    ).href,
                    new URL(
                        '../assets/images/promo/papagou-xolargou/B2C-3.jpg',
                        import.meta.url
                    ).href,
                ],
            },
            {
                title: 'B2B',
                images: [
                    new URL(
                        '../assets/images/promo/papagou-xolargou/B2B-1.jpg',
                        import.meta.url
                    ).href,
                    new URL(
                        '../assets/images/promo/papagou-xolargou/B2B-2.jpg',
                        import.meta.url
                    ).href,
                    new URL(
                        '../assets/images/promo/papagou-xolargou/B2B-3.jpg',
                        import.meta.url
                    ).href,
                ],
            },
        ],

        video: 'https://www.youtube.com/embed/mG-uFO4Ld8I',
    },

    neaionia: {
        name: 'Νέα Ιωνία',

        sections: [
            {
                title: 'B2C',
                images: [
                    new URL(
                        '../assets/images/promo/nea-ionia/B2C-2.jpg',
                        import.meta.url
                    ).href,
                    new URL(
                        '../assets/images/promo/nea-ionia/B2C-1.jpg',
                        import.meta.url
                    ).href,
                    new URL(
                        '../assets/images/promo/nea-ionia/B2C-3.jpg',
                        import.meta.url
                    ).href,
                ],
            },
            {
                title: 'B2B',
                images: [
                    new URL(
                        '../assets/images/promo/nea-ionia/B2B-1.jpg',
                        import.meta.url
                    ).href,
                    new URL(
                        '../assets/images/promo/nea-ionia/B2B-2.jpg',
                        import.meta.url
                    ).href,
                    new URL(
                        '../assets/images/promo/nea-ionia/B2B-3.jpg',
                        import.meta.url
                    ).href,
                ],
            },
        ],

        video: 'https://www.youtube.com/embed/U6ZEO7xbWRM',
    },

    ilioupoli: {
        name: 'Ηλιούπολη',

        sections: [
            {
                title: 'B2C',
                images: [
                    new URL(
                        '../assets/images/promo/ilioupoli/B2C-2.jpg',
                        import.meta.url
                    ).href,
                    new URL(
                        '../assets/images/promo/ilioupoli/B2C-1.jpg',
                        import.meta.url
                    ).href,
                    new URL(
                        '../assets/images/promo/ilioupoli/B2C-3.jpg',
                        import.meta.url
                    ).href,
                ],
            },
            {
                title: 'B2B',
                images: [
                    new URL(
                        '../assets/images/promo/ilioupoli/B2B-1.jpg',
                        import.meta.url
                    ).href,
                    new URL(
                        '../assets/images/promo/ilioupoli/B2B-2.jpg',
                        import.meta.url
                    ).href,
                    new URL(
                        '../assets/images/promo/ilioupoli/B2B-3.jpg',
                        import.meta.url
                    ).href,
                ],
            },
        ],

        video: 'https://www.youtube.com/embed/LkGLca4Ua6M',
    },

    neafiladelfeia: {
        name: 'Νέα Φιλαδέλφεια',

        sections: [
            {
                title: 'B2C',
                images: [
                    new URL(
                        '../assets/images/promo/filadelfeia-xalkidona/B2C-2.jpg',
                        import.meta.url
                    ).href,
                    new URL(
                        '../assets/images/promo/filadelfeia-xalkidona/B2C-1.jpg',
                        import.meta.url
                    ).href,
                    new URL(
                        '../assets/images/promo/filadelfeia-xalkidona/B2C-3.jpg',
                        import.meta.url
                    ).href,
                ],
            },
            {
                title: 'B2B',
                images: [
                    new URL(
                        '../assets/images/promo/filadelfeia-xalkidona/B2B-1.jpg',
                        import.meta.url
                    ).href,
                    new URL(
                        '../assets/images/promo/filadelfeia-xalkidona/B2B-2.jpg',
                        import.meta.url
                    ).href,
                    new URL(
                        '../assets/images/promo/filadelfeia-xalkidona/B2B-3.jpg',
                        import.meta.url
                    ).href,
                ],
            },
        ],

        video: 'https://www.youtube.com/embed/AkP6UHL0PEw',
    },
    zografou: {
        name: 'Ζωγράφου',

        sections: [
            {
                title: 'B2C',
                images: [
                    new URL(
                        '../assets/images/promo/zografou/B2C-2.jpg',
                        import.meta.url
                    ).href,
                    new URL(
                        '../assets/images/promo/zografou/B2C-1.jpg',
                        import.meta.url
                    ).href,
                    new URL(
                        '../assets/images/promo/zografou/B2C-3.jpg',
                        import.meta.url
                    ).href,
                ],
            },
            {
                title: 'B2B',
                images: [
                    new URL(
                        '../assets/images/promo/zografou/B2B-1.jpg',
                        import.meta.url
                    ).href,
                    new URL(
                        '../assets/images/promo/zografou/B2B-2.jpg',
                        import.meta.url
                    ).href,
                    new URL(
                        '../assets/images/promo/zografou/B2B-3.jpg',
                        import.meta.url
                    ).href,
                ],
            },
        ],

        video: 'https://www.youtube.com/embed/OKXfYMDCXA0',
    },
};

const LOCAL_BRANCH = 'zografou';

const getBranchFromHostname = (host) => {
    const hostname = host.toLowerCase().replace(/^www\./, '');

    if (
        process.env.NODE_ENV === 'development' &&
        (hostname === 'localhost' || hostname === '127.0.0.1')
    ) {
        return LOCAL_BRANCH;
    }

    const hostnameToBranch = {
        'papagou-cholargou.eea.gr': 'papagou-cholargou',
        'neaionia.eea.gr': 'neaionia',
        'ilioupoli.eea.gr': 'ilioupoli',
        'neafiladelfeia.eea.gr': 'neafiladelfeia',
        'zografou.eea.gr': 'zografou',
    };

    return hostnameToBranch[hostname] ?? null;
};

const branch = computed(() =>
    getBranchFromHostname(hostname.value)
);

const currentBranch = computed(() =>
    branch.value ? branches[branch.value] ?? null : null
);

const updateHostname = () => {
    hostname.value = window.location.hostname;
};

onMounted(() => {
    updateHostname();
    window.addEventListener('popstate', updateHostname);
});

onUnmounted(() => {
    window.removeEventListener('popstate', updateHostname);
});
</script>

<style scoped>
.promo-video {
    position: relative;
    width: 100%;
    aspect-ratio: 16 / 9;
}

.promo-video iframe {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    border: 0;
}

.promo-image-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 15px;
}

.promo-image {
    display: block;
    width: 75%;
    height: auto;
    margin: 0 auto;
}

.promo-image-actions {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    gap: 10px;
}

.download-icon-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 42px;
    height: 42px;
    padding: 0;
    border-radius: 50%;
}
</style>
